module.exports = __webpack_public_path__ + "img/24_7.a7ff369c.png";